import styled from 'styled-components'

export const ExpTable = styled.table`
  margin-top: 32px;
  width: 100%;
  text-align: left;
`
export const ExpTHead = styled.thead`
  border-bottom: 12px solid transparent;
`
export const ExpTr = styled.tr`
  border-bottom: 5px solid transparent;
`
